/** Env vars arrive as strings; Sentry sample rates must be numbers. */
const numberEnv = (value: string | undefined, fallback: number): number => {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
};

/**
 * tracePropagationTargets must be an ARRAY of URL substrings/prefixes that
 * match the API requests we want linked to backend traces. The env var is a
 * comma-separated list; when absent (or in the legacy JSON-with-regexes format
 * that nothing can parse) we derive the API origin from VITE_SERVER_URL.
 */
const traceTargets = (): string[] => {
    const raw = import.meta.env.VITE_TRACE_PROPAGATION_TARGETS as
        | string
        | undefined;
    if (raw && !raw.trim().startsWith("[")) {
        return raw
            .split(",")
            .map((t) => t.trim())
            .filter(Boolean);
    }
    const targets = ["localhost"];
    try {
        if (import.meta.env.VITE_SERVER_URL) {
            targets.push(new URL(import.meta.env.VITE_SERVER_URL).origin);
        }
    } catch {
        /* invalid VITE_SERVER_URL — keep localhost only */
    }
    return targets;
};

export const configEnv = {
    baseUrl: import.meta.env.VITE_SERVER_URL,
    clientUrl: import.meta.env.VITE_CLIENT_URL,
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    sentryReplaysSessionSampleRate: numberEnv(
        import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
        0.1
    ),
    sentryReplaysOnErrorSampleRate: numberEnv(
        import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
        1.0
    ),
    sentryTracePropagationTargets: traceTargets(),
    sentryEnvironment:
        import.meta.env.VITE_SENTRY_ENVIRONMENT ||
        (import.meta.env.PROD ? "production" : "development"),
    razorpayKeyId: import.meta.env.VITE_RAZORPAY_KEY_ID,
};
